import React, { useState, useEffect } from "react";
import { Card, Row, Col, Button, Form, Alert, Table } from "react-bootstrap";
import Center from "react-center";
import Select from "react-select";
import * as Icons from "react-feather";
import moment from "moment";
import Axios from "axios";
import { urlAPI } from "Common";
import CanvasStep1 from "./CanvasFilter";
//import DataTable from "react-data-table-component";
import Radio from "components/@vuexy/radio/RadioVuexy";
import TableSmall from "./component/TableSmallAntrian";
import TableLarge from "./component/TableLargeAntrian";

const REFRESH_INTERVAL = 60 * 1000; // 1 menit
const initDataDokter = {
  count: 0,
  rows: [],
};
const initDataBooking = {
  NOBOOKING: "",
  PASIEN: null,
  FARMASI: null,
  RADIOLOGI: null,
  LABORATORIUM: null,
  TUJUAN: null,
  NAMAUNIT: null,
};

export default function AntrianSection(props) {
  const {
    filterAntrian,
    setFilterAntrian,
    selectorSBU,
    fetchSelectorUnitAntrian,
    selectorAntrian,
    loadingAntrian,
    setLoadingAntrian,
    setMessageState,
    setShowFailed,
    setShowInfo,
    selectedSBU,
  } = props;
  const [dataTable, setDataTable] = useState({ count: 0, rows: [] });
  const [dataBooking, setDataBooking] = useState(initDataBooking);
  const [loadingLoad, setLoadingLoad] = useState(false);
  const [loadingCari, setLoadingCari] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [sudahCari, setSudahCari] = useState(false);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [pilih, setPilih] = useState("antrian");
  const [openCanvas, setOpenCanvas] = useState(false);
  const [idbook, setIdBook] = useState(null);

  const fetchAntrian = (silent = false) => {
    if (silent) setRefreshing(true);
    Axios.get(
      urlAPI +
        "/public/antrian/infoantrian?params=" +
        JSON.stringify({
          sbu: filterAntrian?.sbu,
          poli: filterAntrian?.poli,
        })
    )
      .then((response) => {
        if (response?.data?.result?.rows?.length > 0) {
          setDataTable({
            ...response?.data?.result,
            rows: response?.data?.result?.rows?.map((obj) => ({
              ...obj
            })),
          });
        } else {
          setDataTable({ rows: [], count: 0 });
        }
        setLastUpdated(moment().format("HH:mm:ss"));
      })
      .catch((err) => {
        if (silent) return;
        const message = err?.response?.message ?? err?.response?.data?.message;
        setMessageState(message);
        if (message === "No Data...") {
          setShowFailed(true);
        } else {
          setShowInfo(true);
        }
      })
      .finally(() => {
        setLoadingLoad(false);
        setRefreshing(false);
      });
  };

  const handleCari = () => {
    setLoadingAntrian(true);
    setLoadingLoad(true);
    setSudahCari(true);
    fetchAntrian();
  };

  const handleRefresh = () => {
    if (refreshing) return;
    fetchAntrian(true);
  };

  /* ---------- cek status pelayanan ---------- */
  const fetchCariData = () => {
    Axios.get(
      urlAPI +
        "/public/antrian/caridata?params=" +
        JSON.stringify({
          NOBOOKING: idbook,
        })
    )
      .then((response) => {
        if (response?.data?.result?.rows?.length !== 0) {
          //console.log("MASUK 1");
          const tempData = response?.data?.result?.rows[0];
          setDataBooking({
            NOBOOKING: tempData?.nobooking,
            PASIEN: tempData?.pasien,
            FARMASI: tempData?.farmasi,
            RADIOLOGI: tempData?.radiologi,
            LABORATORIUM: tempData?.laboratorium,
            TUJUAN: tempData?.tujuan,
            NAMAUNIT: tempData?.namaunit,
          });
          //setLoadingCari(false);
        } else {
          setLoadingCari(false);
        }
      })
      .catch((err) => {
        const message = err?.response?.message ?? err?.response?.data?.message;
        setMessageState(message);
        if (message === "No Data...") {
          setShowFailed(true);
        } else {
          setShowInfo(true);
        }

        setLoadingLoad(false);
      });
  };
  /*eslint-disable */

  useEffect(() => {
    if (filterAntrian?.sbu !== null) {
      setLoadingAntrian(true);
    }
  }, []);

    useEffect(() => {
      if (selectedSBU) {
      setFilterAntrian({
        ...filterAntrian,
        sbu: selectedSBU,
      });
      fetchSelectorUnitAntrian(selectedSBU);
    }
  }, [selectedSBU]);

  // auto refresh tiap 1 menit (hanya setelah user menekan Cari, tab terlihat, dan tab Antrian aktif)
  useEffect(() => {
    if (!sudahCari || pilih !== "antrian" || !filterAntrian?.sbu) return;

    const jitter = Math.floor(Math.random() * 10000); // 0-10 detik, agar request tidak serentak
    const timer = setInterval(() => {
      if (!document.hidden) fetchAntrian(true);
    }, REFRESH_INTERVAL + jitter);

    // saat tab kembali aktif, perbarui satu kali
    const onVisible = () => {
      if (!document.hidden) fetchAntrian(true);
    };
    document.addEventListener("visibilitychange", onVisible);

    return () => {
      clearInterval(timer);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [sudahCari, pilih, filterAntrian?.sbu, filterAntrian?.poli]);
  /*eslint-enable */

  //  console.log("data: ", dataTable);

  return (
    <>
      <style>{`
        @keyframes antrian-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        .antrian-spin { animation: antrian-spin 1s linear infinite; }
      `}</style>
      {/* <h5 style={{ textAlign: "center" }}> */}
      {/* <strong>
          ANTRIAN
          {filterAntrian?.poli !== null && " " + filterAntrian?.namapoli}
        </strong> */}
      {/* </h5> */}
      <br />
      {/* <div className="d-grid gap-2 d-block d-md-none"> */}
      {/* <Button
          block
          variant="warning"
          disabled={loadingLoad}
          onClick={() => {
            setOpenCanvas(true);
          }}
        >
          {loadingLoad ? "Loading..." : " Pilih SBU"}
        </Button> */}
      {/* </div> */}
      <Card>
        <Card.Body>
          <Row>
            <Col lg="6" md="6" sm="12">
              <Radio
                label=" Daftar Antrian Poli"
                color="info"
                name="antrian"
                onClick={() => {
                  setPilih("antrian");
                }}
                checked={pilih === "antrian"}
              />
            </Col>
            <Col lg="6" md="6" sm="12">
              <Radio
                label=" Status Pelayanan"
                color="info"
                name="status"
                onClick={() => {
                  setPilih("status");
                }}
                checked={pilih === "status"}
              />
            </Col>
          </Row>
          <br />
          {/* <Form> */}
          {pilih === "antrian" ? (
            <Row>
              <Col lg="4" md="6" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>Rumah Sakit Tujuan</Form.Label>
                  <Select
                    styles={{
                      color: "black",
                    }}
                    id="sbu"
                    name="sbu"
                    options={selectorSBU}
                    value={selectorSBU.find(
                      (find) => find?.value === filterAntrian?.sbu
                    )}
                    onChange={(e) => {
                      fetchSelectorUnitAntrian(e.value);
                      setFilterAntrian({
                        ...filterAntrian,
                        sbu: e.value,
                        poli: null,
                      });
                    }}
                  />
                </Form.Group>
              </Col>
              {/* <Col lg="6" md="6" sm="12">
              <Radio
                label=" Eksklusif"
                color="info"
                name="jenis"
                onClick={() => {
                  setPilih("jenis");
                }}
                checked={pilih === "jenis"}
              />
            </Col>
            <Col lg="6" md="6" sm="12">
              <Radio
                label=" Reguler"
                color="info"
                name="jenis"
                onClick={() => {
                  setPilih("jenis");
                }}
                checked={pilih === "jenis"}
              />
            </Col> */}

              <Col lg="4" md="6" sm="12">
                <div className="d-grid gap-2" style={{ paddingTop: "32px" }}>
                  <Button
                    block
                    style={{
                      background: "linear-gradient(135deg, #56ab2f, #a8e063)",
                      border: "none",
                      color: "#fff",
                    }}
                    disabled={loadingLoad}
                    onClick={handleCari}
                  >
                    {loadingLoad ? "Loading..." : "Cari"}
                  </Button>
                </div>
              </Col>
            </Row>
          ) : (
            <Row>
              <Col lg="4" md="6" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>Nomor Booking</Form.Label>
                  <Form.Control
                    type="text"
                    id="nomor"
                    name="nomor"
                    onChange={(e) => setIdBook(e.target.value.toUpperCase())}
                  />
                </Form.Group>
              </Col>
              <Col lg="4" md="6" sm="12">
                <div className="d-grid gap-2" style={{ paddingTop: "32px" }}>
                  <Button
                    block
                    variant="warning"
                    onClick={() => {
                      setLoadingCari(true);
                      setDataBooking(initDataBooking);
                      fetchCariData();
                    }}
                  >
                    Cari
                  </Button>
                </div>
              </Col>
            </Row>
          )}
          {/* </Form> */}
        </Card.Body>
      </Card>
      {pilih === "antrian" ? (
        <>
          {loadingLoad ? (
            <>
              <br />
              <Center>
                <h3>Loading...</h3>
              </Center>
            </>
          ) : (
            <>
              <br />

              {/* ---------- Info & tombol perbarui ---------- */}
              {sudahCari && (
                <div
                  style={{
                    background: "#f4f8fc",
                    border: "1px solid #dce7f3",
                    borderLeft: "4px solid #1890ff",
                    borderRadius: "8px",
                    padding: "14px 18px",
                    marginBottom: "16px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      flexWrap: "wrap",
                      gap: "10px",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <Icons.Info size={16} style={{ color: "#1890ff", flexShrink: 0 }} />
                      <strong style={{ color: "#2c3e50", fontSize: "14px" }}>
                        Informasi Antrian
                      </strong>
                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                      {lastUpdated && (
                        <span style={{ fontSize: "12px", color: "#78909c" }}>
                          Diperbarui {lastUpdated} WIB
                        </span>
                      )}
                      <Button
                        size="sm"
                        variant="outline-primary"
                        disabled={refreshing}
                        onClick={handleRefresh}
                        style={{ display: "flex", alignItems: "center", gap: "6px" }}
                      >
                        <Icons.RefreshCw
                          size={14}
                          className={refreshing ? "antrian-spin" : ""}
                        />
                        {refreshing ? "Memperbarui..." : "Perbarui"}
                      </Button>
                    </div>
                  </div>

                  <p
                    style={{
                      margin: "10px 0 0",
                      fontSize: "13px",
                      lineHeight: 1.6,
                      color: "#546e7a",
                    }}
                  >
                    Data antrian diperbarui secara otomatis setiap 1 menit. Untuk
                    memperoleh informasi terkini, silakan tekan tombol{" "}
                    <strong>Perbarui</strong>
                  </p>
                </div>
              )}

              <div className="d-block d-lg-none">
                <TableSmall dataTable={dataTable} />
              </div>
              <div className="d-none d-lg-block">
                <TableLarge dataTable={dataTable} />
              </div>

              {/* <DataTable
                data={!dataTable?.rows ? dataTable?.rows : [...dataTable?.rows]}
                progressPending={loadingLoad}
                noHeader
                pagination
                columns={[
                  {
                    name: "NAMA POLI",
                    sortable: false,
                    cell: (row) => row?.namaunit,
                    width: "150px",
                  },

                  {
                    name: "ANTRIAN",
                    sortable: false,
                    cell: (row) => (
                      <div style={{ fontSize: 20 }}>
                        {row?.antrian + "/" + row?.total}{" "}
                      </div>
                    ),
                    // cell: row => <div style={{fontSize: 25}}>{row.title}</div>
                    width: "90px",
                  },
                  {
                    name: "DOKTER",
                    sortable: false,
                    cell: (row) => row?.dokter,
                  },
                ]}
              /> */}
            </>
          )}
        </>
      ) : (
        <>
          {loadingCari ? (
            <Row>
              <Col lg="4" md="6" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>Nomor Booking</Form.Label>
                  <Form.Control
                    type="text"
                    id="nomor"
                    name="nomor"
                    value={dataBooking?.NOBOOKING}
                    disabled={true}
                  />
                </Form.Group>
              </Col>
              <Col lg="4" md="6" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>Nama Pasien</Form.Label>
                  <Form.Control
                    type="text"
                    id="nomor"
                    name="nomor"
                    value={dataBooking?.PASIEN}
                    disabled={true}
                  />
                </Form.Group>
              </Col>
              <Col lg="4" md="6" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>Nama Unit Periksa</Form.Label>
                  <Form.Control
                    type="text"
                    id="nomor"
                    name="nomor"
                    value={dataBooking?.NAMAUNIT}
                    disabled={true}
                  />
                </Form.Group>
              </Col>
              <Col lg="4" md="6" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>FARMASI</Form.Label>
                  <Form.Control
                    type="text"
                    id="nomor"
                    name="nomor"
                    value={dataBooking?.FARMASI}
                    disabled={true}
                  />
                </Form.Group>
              </Col>
              <Col lg="4" md="6" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>RADIOLOGI</Form.Label>
                  <Form.Control
                    type="text"
                    id="nomor"
                    name="nomor"
                    value={dataBooking?.RADIOLOGI}
                    disabled={true}
                  />
                </Form.Group>
              </Col>
              <Col lg="4" md="6" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>LABORATORIUM</Form.Label>
                  <Form.Control
                    type="text"
                    id="nomor"
                    name="nomor"
                    value={dataBooking?.LABORATORIUM}
                    disabled={true}
                  />
                </Form.Group>
              </Col>
            </Row>
          ) : (
            <>
              <br />
              <center>
                <h6>Data Tidak Ditemukan</h6>
              </center>
            </>
          )}
        </>
      )}
    </>
  );
}
